import { render, staticRenderFns } from "./LoanReports.vue?vue&type=template&id=9c57a3e4&scoped=true"
import script from "./LoanReports.vue?vue&type=script&lang=js"
export * from "./LoanReports.vue?vue&type=script&lang=js"
import style0 from "./LoanReports.vue?vue&type=style&index=0&id=9c57a3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c57a3e4",
  null
  
)

export default component.exports